import clsx from "clsx";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import MenuIcon from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";

import "./style.css";
import { Ribbon } from "../../commons/Ribbon";
import { useObservable } from "src/framework/store/storeUtil";
import { MenuUserInfo, UserInfo } from "../MenuUserInfo";
import TabHeader from "../tabs/TabHeader";
import { UserClassificacaoInfo } from "../UserClassificaoInfo";
import { CacheType, contaUsuario$, getContaUsuario } from "src/store/global.store";
import { ContaUsuario } from "src/store/global.store.types";
import { Notifications } from "../../commons/Popups/Notifications/index";
import { useEffect, useState } from "react";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { useMediaQuery, useTheme } from "@mui/material";
import { LoginStore } from "src/framework/store/LoginStore";
import { openMenu$, standAlonePage$ } from "src/framework/store/ApiEvents";

const ApplicationBar = ({ classes }: { classes: any }) => {
  const ambiente = `${process.env.REACT_APP_ENV_LABEL}`
  const isProd = String(process.env.REACT_APP_IS_PROD).toUpperCase() === "TRUE";
  const standAlonePage = useObservable(standAlonePage$);
  const contaUsuario = useObservable<CacheType<ContaUsuario | null>>(contaUsuario$);
  const openMenu = useObservable(openMenu$);
  const permissoes = PermissionUtil.getPermissions();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const authUser = useObservable(LoginStore.userInfoSubject())
  let userInfo: UserInfo = {
    name: `${authUser?.name || authUser?.user}`,
    email: `${authUser?.email}`,
  };

  const [reload, setRelaod] = useState<boolean>(false);

  useEffect(() => {
    if (!contaUsuario?.data && !reload) {
      getContaUsuario();
      setRelaod(true);
    }
  }, [reload, contaUsuario])
  
  const TABS = [
    {
      label: "Plataforma Solar",
      link: "/"
    },
  ];

  if (!permissoes.length) return null

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar className={classes.toolBar}>
        <Box display="flex" alignItems="center" flex={1}>
          {!isProd ? <Ribbon label={ambiente} side="left" /> : ""}
          {standAlonePage ? "" : (
            <IconButton
              color="secondary"
              aria-label="open drawer"
              onClick={(e) => {
                e.preventDefault();
                setTimeout(() => openMenu$.next(!openMenu), 300);
              }}
              onDoubleClick={(e) => e.preventDefault()}
              edge="start"
              className={clsx(classes.menuButton)}
              size="large">
              <MenuIcon />
            </IconButton>
          )}

          {!isMobile && (
            <Box className="box-header">
              <TabHeader tabs={TABS} />
            </Box> 
          )}
        </Box>

        <Box display="flex" justifyContent='flex-end'>
          <Box display="flex">
            <Notifications/>
          </Box>
        </Box>

        <Box display="flex" justifyContent='flex-end'>
           {!isMobile && <UserClassificacaoInfo userInfo={userInfo} contaUsuario={contaUsuario?.data} /> }
          <Box width={"auto"}>
            <MenuUserInfo user={userInfo} />
          </Box>
        </Box>

      </Toolbar>
    </AppBar>
  );
};

export { ApplicationBar };
